<template>
    <li class="motor" :class="{active, available}" @click="selectMotor(motor)">
        <img class="icon" :src="getIcon(available)" alt="available">
        <span class="power" v-text="motor.title"></span>
        <span class="kwh">{{ motor.kw}} kW</span>
    </li>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: 'Motor',

    props: ['motor', 'isAvailable'],

    computed: {
      ...mapState({
        selectedMotor: state => state.preference.selectedMotorGroup,
        resetMotorOptions: state => state.preference.motorOptions,
      }),
      active() {
        return this.selectedMotor === this.motor;
      },
      available() {
        return this.isAvailable;
      },
    },
    methods: {
      selectMotor() {
        if (!this.active) {
          this.$store.dispatch('preference/selectMotorGroup', this.motor);
          // this.$store.dispatch('preference/selectMotor', this.motor);
          // this.$store.dispatch('build/selectMotor', this.motor.id);

          this.resetOptions();
        }
      },
      getIcon() {
        return this.available ? this.active ? this.getImage('check-motor-white.svg') : this.getImage('check-motor.svg') : this.getImage('cross-motor.svg')
      },
      resetOptions() {
          return this.$store.dispatch('preference/resetOptions');
      },
    },
  }
</script>

<style lang="scss">
    .motor {
        display: block;
        position: relative;
        margin: 0;
        transition: all ease 0.3s;
        padding: 4px 15px 2px;
        cursor: pointer;

        &:not(.active):hover {
            .icon {
                margin-right: 15px;
            }
        }

        &:before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            top: 0;
            width: 0;
            transition: all ease 0.3s;
            z-index: 0;
        }

        .icon {
            width: 13px;
            height: 13px;
            margin-right: 10px;
            margin-bottom: 6px;
            transition: all ease 0.3s;
            position: relative;
            z-index: 1;
        }

        .power {
            display: inline-block;
            font-size: 14px;
            font-family: neue-haas-grotesk-text, sans-serif;
            font-weight: 400;
            color: #D7D7D7;
            margin-right: 10px;
            transition: all ease 0.3s;
            position: relative;
            z-index: 1;
        }

        .kwh {
            font-family: neue-haas-grotesk-display, sans-serif;
            color: #D7D7D7;
            transition: all ease 0.3s;
            position: relative;
            z-index: 1;
            font-size: 12px;
        }

        &:after {
            content: '';
            position: absolute;
            right: 15px;
            top: 0;
            bottom: 0;
            width: 8px;
            background: url(../../../assets/arrow-right.svg) no-repeat center;
            background-size: 5px 8px;
            opacity: 0;
            transition: all ease 0.3s;
            z-index: 1;
        }

        &.available {

            .power {
                color: black;
            }

            .kwh {
                color: black;
            }

            &:after {
                opacity: 1;
            }
        }

        &.active {
            letter-spacing: 1px;

            &:before {
                width: 100%;
                background-color: #3DB0C7;
            }

            .power {
                color: #fff;
            }

            .kwh {
                color: #fff;
                font-weight: unset;
            }

            &:after {
                filter: brightness(4);
            }
        }
    }
</style>
